module.exports = __webpack_public_path__ + "static/media/home.94687aca.svg";